<template>
  <div>
    <h6 :class="isAdminOnly ? 'text-danger' : ''">
      {{ question.label }} {{ question.required ? '*' : '' }}
      <small v-if="isAdminOnly" :title="trans('visible_only_administrators')" v-b-tooltip.hover>
        <i class="fa fa-fw fa-info-circle"></i>
      </small>
    </h6>
    <div :class="`mb-2 ${isAdminOnly ? 'text-danger' : ''}`" v-html="question.description"></div>
    <b-form-group :id="`form-question-${this.question.slug}`" :tabindex="!!buttonPopoverHtml ? 0 : null">
      <file-pond
        :name="`upload_${mediaType}`"
        ref="pond"
        :server="serverConfig"
        :files="files"
        :label-idle="trans('pond_idle')"
        :allow-multiple="multiple"
        :accepted-file-types="fileTypes"
        :label-file-processing="trans('pond_file_processing')"
        :label-file-type-not-allowed="trans('pond_file_type_not_allowed')"
        :label-file-processing-error="trans('pond_file_processing_error')"
        :label-tap-to-cancel="trans('pond_label_tap_to_cancel')"
        :label-tap-to-retry="trans('pond_label_tap_to_retry')"
        :label-tap-to-undo="trans('pond_label_tap_to_undo')"
        :label-file-processing-complete="trans('pond_label_file_processing_complete')"
        :label-file-processing-aborted="trans('pond_label_file_processing_aborted')"
        :disabled="!!buttonPopoverHtml"
        @init="oninit"
        @processfilestart="onprocessfilestart"
        @processfileabort="onprocessfileabort"
        @processfile="onprocessfile"
        @removefile="onremovefile"
      />
      <b-form-input
        type="text"
        :name="question.slug"
        :value="umids"
        :required="question.required"
        style="opacity:0;display:block;height:1px;padding:0;margin:0;"
      />
      <b-form-invalid-feedback :state="!!errors ? false : null">
        {{ (errors||[]).join(' ') }}
      </b-form-invalid-feedback>
    </b-form-group>
    <b-popover
      v-if="!!buttonPopoverHtml"
      :target="`form-question-${this.question.slug}`"
      triggers="click blur"
      placement="bottom"
      :title="trans('form_design')"
    >
      <div v-html="buttonPopoverHtml"></div>
    </b-popover>
  </div>
</template>

<script>
  import vueFilePond from "vue-filepond"
  import "filepond/dist/filepond.min.css"
  import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type"
  const FilePond = vueFilePond(FilePondPluginFileValidateType)

  export default {
    props: {
      mediaCollection: String, // images, videos or documents
      url: String, // base URL
      value: Array, // answer is an array of files (see serialize)
      question: Object,
      disabled: {
        type: Boolean,
        default: false,
      },
      size: {
        type: String,
        default: 'md',
      },
      errors: Array,
      buttonPopoverHtml: String, // We are in design mode when present. Do not permit upload.
    },
    components: {
      FilePond,
    },
    data() {
      return {
        trans: trans,
        answer: this.value || [],
        files: undefined,
      }
    },
    computed: {
      isAdminOnly() {
        return this.question.visibility == 'admin_only'
      },
      mediaType() {
        return this.mediaCollection == 'images' ? 'image' :
          (this.mediaCollection == 'documents' ? 'document' :
          (this.mediaCollection == 'videos' ? 'video' : 'audio'))
      },
      fileTypes() {
        if (this.mediaCollection == 'documents')
          return 'application/pdf, application/msword, application/vnd.openxmlformats, officedocument.wordprocessingml.document, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.presentationml.presentation, application/vnd.openxmlformats-officedocument.wordprocessingml.document'
        if (this.mediaCollection == 'audios')
          return 'audio/mpeg, audio/mp3, audio/flac, audio/wav, audio x-wav, audio/m4a, audio/x-m4a'
        return this.mediaCollection == 'images' ?
          'image/jpeg, image/png, image/gif, image/webp, application/pdf' : 
          'video/mp4, video/quicktime, video/3gpp, video/webm, video/m4v'
      },
      multiple() {
        return this.question.options && this.question.options.multiple ? this.question.options.multiple : false
      },
      serverConfig() {
        return {
          process: (this.url || window.location.href).split('?')[0] + `/upload_${this.mediaType}`,
          revert: (this.url || window.location.href).split('?')[0] + '/delete_uploaded_media',
          fetch: null,
          headers: {
              'X-CSRF-TOKEN': _.csrf,
          },
        }
      },
      umids() {
        // The input is only used for required.
        // So we serialize the umids to satisfy this.
        return _.map(this.answer || [], file => {
          return file.umid
        }).join(',')
      },
    },
    watch: {
      answer() {
        this.$emit('input', this.answer)
      },
      value() {
        this.answer = this.value || []
      },
    },
    methods: {
      oninit() {
        this.files = _.map(this.value || [], file => {
          return {
            source: file.umid,
            options: {
              type: 'limbo',
              file: {
                name: file.name,
                size: file.size,
                type: file.type,
              }
            }
          }
        })
      },
      onprocessfilestart() {
        this.$emit('clear-error', this.question.slug)
        this.$emit('busy', true)
      },
      onprocessfileabort() {
        this.$emit('busy', false)
      },
      onprocessfile(error, file) {
        this.$emit('busy', false)
        this.answer = this.serialize()
      },
      onremovefile(error, file) {
        this.$emit('busy', false)
        this.answer = this.serialize()
      },
      serialize() {
        return this.$refs.pond.getFiles().map(file => {
          return {
            umid: file.serverId,
            name: file.filename,
            size: file.fileSize,
            //type: ?? // mime type is not available here - will be set by server
          }
        })
      }
    },
    mounted() {
      window['formQuestion_'+this.question.slug] = this
    },
  }
</script>